import { useRef } from 'react'

import { EpostFormContext } from '../EpostForm.context'

function EpostFormProvider({ children, externalRef, ...restProps }) {
  // to have access to formik context
  const innerRef = useRef(null)

  function setInnerRef(node) {
    if (externalRef) {
      externalRef.current = node
    }

    innerRef.current = node
  }

  return (
    <EpostFormContext value={{ ...restProps, innerRef, setInnerRef }}>
      {children}
    </EpostFormContext>
  )
}

export default EpostFormProvider
